<script lang="ts">
    import { Table } from 'sveltestrap'
    import {getBalanceByUserId} from 'src/components/cabinet/#services/getBalanceByUserId'
    import {getStakingBalanceByUserId} from 'src/components/cabinet/#services/getStakingBalanceByUserId'
    import {getUserLisWallet} from 'src/components/cabinet/#services/getUserLisWallet'
    import {getProfile} from 'src/components/cabinet/#services/getUserProfile'
    import {userRole} from 'src/components/#common/myRole'
    import {setUserNotice} from 'src/components/cabinet/#services/setUserNotice'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {getUserPolygonWallet} from 'src/components/cabinet/#services/evmAdapter'
    import IconifyIcon from '@iconify/svelte'
    import dropdownIcon from '@iconify/icons-fa-solid/caret-square-down'
    import { slide } from 'svelte/transition';

    export let userId

    $: userId, getProfile.reset(), getProfile.send({data:{userId}}), userRole.send({data:{userId}}),
        getBalanceByUserId.send({data:{userId}}), getStakingBalanceByUserId.send({data:{userId}}),
        getUserLisWallet.send({data:{userId}}), getUserPolygonWallet.send({data:{userId}}), userNotice = undefined

    let userNotice
    $: if (userNotice === undefined && $getProfile.hasValue) {
        userNotice = $getProfile.value && JSON.parse(JSON.stringify($getProfile.value.notice))
    }

    let dropdownLisOpen = false
    let dropdownDogeOpen = false
    let dropdownPepeOpen = false

    async function setUserNoticeHandler() {
        try {
            await setUserNotice.request({ data: {
                userId,
                msg: userNotice
            }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        }
    }
</script>

{#if !$getProfile.hasValue && $getProfile.loading}
    <div class="profile-info">
        <Table responsive>
            <tbody>
                <tr><td colspan="2">Loading...</td></tr>
            </tbody>
        </Table>
    </div>
{:else if !$getProfile.hasValue && $getProfile.error}
    <div class="profile-info">
        <div class="badges">
            <span class="badge badge-deleted" title="Maybe it's a guest profile">Profile not found</span>
        </div>
    </div>
{:else if $getProfile.hasValue}
    <div class="profile-info">
        <div class="badges">
            {#if $userRole.hasValue && $userRole.value}
                <span class="badge badge-admin">{$userRole.value}</span>
            {/if}
            {#if $getProfile.value.lifeTimeInterest}
                <span class="badge badge-interest">Lifetime interest ({$getProfile.value.lifeTimeInterestPercent}%)</span>
            {/if}
            {#if $getProfile.value.isBanned}
                <span class="badge badge-banned">Banned</span>
            {/if}
            {#if $getProfile.value.isDeleted}
                <span class="badge badge-deleted">Deleted</span>
            {/if}
            {#if $getProfile.value.suspicious}
                <span class="badge badge-suspicious">Suspicious</span>
            {/if}
        </div>
        <Table responsive>
            <tbody>
            <tr>
                <td><strong>Support ID</strong>:</td>
                <td>{$getProfile.value.userId}</td>
            </tr>
            <tr>
                <td><strong>Nickname</strong>:</td>
                <td>{$getProfile.value.nickname}</td>
            </tr>
            <tr>
                <td><strong>Email</strong>:</td>
                <td>{$getProfile.value?.email || " "}</td>
            </tr>
            </tbody>
        </Table>
    </div>
{/if}
{#if $getBalanceByUserId.hasValue}
    <div class="profile-info">
        <Table responsive>
            <tbody>
                <tr>
                    <td><strong>LIS balance</strong>:</td>
                    <td>{(+$getBalanceByUserId.value.BLIS + +$getBalanceByUserId.value.PLIS + +$getBalanceByUserId.value.LIS + +$getBalanceByUserId.value.PWLIS + +$getBalanceByUserId.value.WLIS).toFixed(4)} LIS</td>
                    <td style="padding: 0">
                        <button class="btn" on:click={() => dropdownLisOpen = !dropdownLisOpen} style="box-shadow: none">
                            <IconifyIcon icon={dropdownIcon} rotate={dropdownLisOpen ? '180deg' : '0deg'}/>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding: 0; border: 0;">
                        {#if dropdownLisOpen}
                            <div transition:slide={{ delay: 250, duration: 300 }} style="background: #f7f7f7;">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td><strong>Bonus balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.BLIS} LIS</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PLIS} LIS</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.LIS} LIS</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase wallet balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PWLIS} LIS</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Wallet balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.WLIS} LIS</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </div>
                        {/if}
                    </td>
                </tr>
                <!--
                <tr>
                    <td><strong>Staking balance</strong>:</td>
                    {#if $getStakingBalanceByUserId.hasValue}
                        <td>{$getStakingBalanceByUserId.value?.LIS} LIS</td>
                    {:else}
                        <td>Loading...</td>
                    {/if}
                </tr>
                -->
                <tr>
                    <td><strong>Near balance</strong>:</td>
                    <td>{$getBalanceByUserId.value.NEAR} NEAR</td>
                </tr>
                <tr>
                    <td><strong>USDT balance</strong>:</td>
                    <td>{$getBalanceByUserId.value.USDT} USDT</td>
                </tr>
                <tr>
                    <td><strong>Matic balance</strong>:</td>
                    <td>{$getBalanceByUserId.value.MATIC} MATIC</td>
                </tr>
                <tr>
                    <td><strong>Doge balance</strong>:</td>
                    <td>{(+$getBalanceByUserId.value.DOGE + +$getBalanceByUserId.value.WDOGE + +$getBalanceByUserId.value.PDOGE + +$getBalanceByUserId.value.PWDOGE + +$getBalanceByUserId.value.BDOGE).toFixed(4)} DOGE</td>
                    <td style="padding: 0">
                        <button class="btn" on:click={() => dropdownDogeOpen = !dropdownDogeOpen} style="box-shadow: none">
                            <IconifyIcon icon={dropdownIcon} rotate={dropdownDogeOpen ? '180deg' : '0deg'}/>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding: 0; border: 0;">
                        {#if dropdownDogeOpen}
                            <div transition:slide={{ delay: 250, duration: 300 }} style="background: #f7f7f7;">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td><strong>Bonus balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.BDOGE} DOGE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PDOGE} DOGE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.DOGE} DOGE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase Wallet balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PWDOGE} DOGE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Wallet balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.WDOGE} DOGE</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </div>
                        {/if}
                    </td>
                </tr>
                <tr>
                    <td><strong>Pepe balance</strong>:</td>
                    <td>{(+$getBalanceByUserId.value.PEPE + +$getBalanceByUserId.value.WPEPE + +$getBalanceByUserId.value.PPEPE + +$getBalanceByUserId.value.PWPEPE + +$getBalanceByUserId.value.BPEPE).toFixed(4)} PEPE</td>
                    <td style="padding: 0">
                        <button class="btn" on:click={() => dropdownPepeOpen = !dropdownPepeOpen} style="box-shadow: none">
                            <IconifyIcon icon={dropdownIcon} rotate={dropdownPepeOpen ? '180deg' : '0deg'}/>
                        </button>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="padding: 0; border: 0;">
                        {#if dropdownPepeOpen}
                            <div transition:slide={{ delay: 250, duration: 300 }} style="background: #f7f7f7;">
                                <Table responsive>
                                    <tbody>
                                    <tr>
                                        <td><strong>Bonus balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.BPEPE} PEPE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PPEPE} PEPE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Game balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PEPE} PEPE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Purchase Wallet Pepe</strong>:</td>
                                        <td>{$getBalanceByUserId.value.PWPEPE} PEPE</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Wallet balance</strong>:</td>
                                        <td>{$getBalanceByUserId.value.WPEPE} PEPE</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </div>
                        {/if}
                    </td>
                </tr>
                <!--
                <tr>
                    <td><strong>Testnet balance</strong>:</td>
                    <td>{$getBalanceByUserId.value.TLIS} LIS</td>
                </tr>
                -->
                {#if $getUserLisWallet.hasValue && $getUserLisWallet.value.address}
                    <tr>
                        <td><strong>LIS wallet</strong>:</td>
                        <td>
                            <a href="https://nearblocks.io/address/{$getUserLisWallet.value?.address}" target="_blank" rel="noreferrer">
                                {#if $getUserLisWallet.value?.address.length >= 20}
                                    {$getUserLisWallet.value?.address.slice(0,7)}...{$getUserLisWallet.value?.address.slice(-7)}
                                {:else}
                                    {$getUserLisWallet.value?.address}
                                {/if}
                            </a>
                        </td>
                    </tr>
                {/if}
                {#if $getUserPolygonWallet.hasValue && $getUserPolygonWallet.value}
                    <tr>
                        <td><strong>Polygon wallet</strong>:</td>
                        <td>
                            <a href="https://polygonscan.com/address/{$getUserPolygonWallet.value}" target="_blank" rel="noreferrer">
                                {$getUserPolygonWallet.value.slice(0,7)}...{$getUserPolygonWallet.value.slice(-7)}
                            </a>
                        </td>
                    </tr>
                {/if}
            </tbody>
        </Table>
    </div>
{/if}
{#if $getProfile.hasValue}
    <div class="profile-info">
        <Table responsive>
            <tbody>
                <tr>
                    <td><strong>Registered</strong>:</td>
                    <td>{new Date($getProfile.value.registeredAt).toLocaleString()}</td>
                </tr>
                {#if $getProfile.value?.lastActivity}
                <tr>
                    <td><strong>Last activity</strong>:</td>
                    <td>{new Date($getProfile.value.lastActivity).toLocaleString()}</td>
                </tr>
                {/if}
            </tbody>
        </Table>
        <div class="form-group">
            <div class="input-group">
                <textarea class="form-control note" bind:value={userNotice}></textarea><br>
            </div>
            <div class="input-group">
                <button class="btn btn-primary" on:click={setUserNoticeHandler}>Save</button>
            </div>
        </div>
    </div>
{/if}

<style>
    .profile-info :global(table) {
        width: auto;
        margin-bottom: 0;
    }

    .profile-info :global(td strong) {
        font-weight: 500;
    }

    .profile-info :global(td:first-child) {
        min-width: 210px;
    }

    .badges {
        margin-bottom: 10px;
    }

    .badge {
        display: inline-block;
        padding: .5em .8em;
        font-size: .75em;
        font-weight: 500;
        line-height: 1;
        color: white;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        margin-right: 6px;
        cursor: default;
    }

    .badge-admin {
        background: #ff5d1c;
    }

    .badge-interest {
        background: #4caf50;
    }

    .badge-banned {
        background: #da2e20;
    }

    .badge-deleted {
        background: #da2e20;
    }

    .badge-suspicious {
        background: #e97624;
    }

    .note {
        max-width: 400px;
        background: #fffdca;
        margin: 20px 0;
        min-height: 110px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        border: 0;
        font-size: 15px;
        line-height: normal;
        border-radius: 0;
        transition: .5s;
    }

    .note:hover {
        box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
    }
</style>
